import { createReducer } from 'redux-starter-kit';
import {
  request, requestSuccess, requestFailure, requestCancel,
} from './RequestActions';


export const selectRequest = (state, id) => state.via.domain.requests[id];


const requestInitialState = {
  isLoading: false,
  error: null,
  payload: null,
};

// A dict object with a property key of: id and a property value of: request
const requestsInitialState = {
  // id: {
  //  isLoading: /* true/false */,
  //  error: /* null or string */
  //  payload: /* null or any */
  // }
  // id: { /* etc */ }
  // ..etc
};


const requestReducer = createReducer(requestsInitialState, {
  [request]: (state, { payload }) => ({
    ...state,
    [payload]: {
      ...requestInitialState,
      isLoading: true,
    },
  }),

  [requestSuccess]: (state, { payload }) => ({
    ...state,
    [payload.id]: {
      ...requestInitialState,
      isLoading: false,
      payload: payload.payload,
    },
  }),

  [requestFailure]: (state, { payload }) => ({
    ...state,
    [payload.id]: {
      ...requestInitialState,
      isLoading: false,
      error: payload.payload,
    },
  }),

  [requestCancel]: (state, { payload }) => ({
    ...state,
    [payload.id]: {
      ...requestInitialState,
      isLoading: false,
      error: null,
    },
  }),
});

export default requestReducer;
